import { render } from "./AdminReview.vue?vue&type=template&id=2a9362dc"
import script from "./AdminReview.vue?vue&type=script&lang=js"
export * from "./AdminReview.vue?vue&type=script&lang=js"

import exportComponent from "/Users/georgwidschwendter/Documents/GitHub/learn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__